import React from 'react';
import { Link } from 'react-router-dom';
import useScrollReveal from '../../hooks/useScrollReveal';
import logoBrahmos  from '../../assets/miltech logo/BrahMos_Aerospace.svg.png';
import logoFLSmidth from '../../assets/miltech logo/FLSmidth.png';
import logoIGCAR    from '../../assets/miltech logo/Indira_Gandhi_Centre_for_Atomic_Research_Logo.png';
import logoLT       from '../../assets/miltech logo/L&T (DEFENCE, ECC, Rubber Processing Machinery), Chennai..png';
import logoLPSC     from '../../assets/miltech logo/Liquid_Propulsion_Systems_Centre_Logo.png';
import logoVSSC     from '../../assets/miltech logo/VIKRAM SARABHAI SPACE RESEARCH CENTRE, Thiruvananthapuram. logo.png';
import visionImg    from '../../assets/Our Vision.jpg';
import missionImg   from '../../assets/our_mission-removebg-preview.png';
import qualityImg   from '../../assets/quality-removebg-preview.png';
import aboutBanner  from '../../assets/another page banner/about us.jpg';
import './AboutUs.css';

const TIMELINE = [
  { year: '2002', title: 'Unit I Founded', desc: 'MILLTECH CNC established with Unit I at Thirumudivakkam, Chennai with VMC and VTL machines. Starting the journey of heavy engineering excellence.' },
  { year: '2010', title: 'ISRO Partnership', desc: 'First critical aerospace components delivered to ISRO. Beginning of a long-standing trust relationship.' },
  { year: '2014', title: 'Unit II Commissioned', desc: 'Heavy Duty Machining Unit II commissioned with the landmark BERTHIEZ 8.2m VTL and KOLB 12.5m Gantry machine at Thirumudivakkam.' },
  { year: '2015', title: 'ISO 9001:2015 Certified', desc: 'Unit I achieves ISO 9001:2015 certification — confirming our quality management system excellence.' },
  { year: '2020', title: 'BrahMos Approved', desc: 'Certified supplier for BrahMos Aerospace missile sub-assemblies and structural components.' },
  { year: '2023', title: 'Gaganyaan Programme', desc: "CEOS Adaptor Assembly manufactured for VSSC's Gaganyaan — India's first human spaceflight mission." },
];

const CLIENTS = [
  { name: 'ISRO – VSSC',       full: 'Vikram Sarabhai Space Research Centre, Thiruvananthapuram', logo: logoVSSC,     color: '#F59E0B' },
  { name: 'LPSC – ISRO',       full: 'Liquid Propulsion System Centre, ISRO',                      logo: logoLPSC,     color: '#7C3AED' },
  { name: 'BrahMos Aerospace',  full: 'BrahMos Aerospace Thiruvananthapuram Limited',               logo: logoBrahmos,  color: '#4F46E5' },
  { name: 'IGCAR',              full: 'Indira Gandhi Centre for Atomic Research, Kalpakkam',        logo: logoIGCAR,    color: '#10B981' },
  { name: 'L&T',                full: 'L&T (Defence, ECC, Rubber Processing Machinery), Chennai',   logo: logoLT,       color: '#E8192C' },
  { name: 'FLSmidth',           full: 'FLSmidth, Chennai',                                          logo: logoFLSmidth, color: '#0EA5E9' },
];

// Vision / Mission / Quality with actual asset images
const VMQ = [
  {
    img: visionImg,
    heading: 'Our Vision',
    text: 'To become a leader in products and services of Special Machining and Fabrication.',
    color: 'var(--indigo)',
    bg: 'rgba(30,58,138,0.06)',
    border: 'rgba(30,58,138,0.15)',
  },
  {
    img: missionImg,
    heading: 'Our Mission',
    text: 'Drive continuous improvement utilizing Lean Manufacturing principles and employee involvement to achieve Customer Satisfaction.',
    color: 'var(--red)',
    bg: 'rgba(200,16,46,0.05)',
    border: 'rgba(200,16,46,0.15)',
  },
  {
    img: qualityImg,
    heading: 'Quality Policy',
    text: 'Consistently provide Products and Services of Fabrication and Machining that achieve Total Customer Satisfaction by continuously improving processes and Quality System.',
    color: 'var(--emerald)',
    bg: 'rgba(5,150,105,0.06)',
    border: 'rgba(5,150,105,0.15)',
  },
];

const AboutUs = () => {
  const timelineRef  = useScrollReveal();
  const whoRef       = useScrollReveal();
  const locationRef  = useScrollReveal();
  const clientsRef   = useScrollReveal();

  return (
    <main className="about-page">

      {/* ── PAGE HEADER — with banner image ── */}
      <section className="about-page-header">
        <div className="about-page-header__bg">
          <img src={aboutBanner} alt="About MILLTECH CNC" className="about-page-header__bg-img" />
          <div className="about-page-header__bg-overlay" />
        </div>
        <div className="container about-page-header__content">

          <h1 className="about-page-header__title">About <span>MILLTECH</span></h1>
          <p className="about-page-header__sub">Two decades of excellence. One passion — Engineering accuracy.</p>
          <div className="about-page-header__stats">
            <div className="about-hero-stat"><span className="about-hero-stat__num">25+</span><span className="about-hero-stat__lbl">Years</span></div>
            <div className="about-hero-stat__div"/>
            <div className="about-hero-stat"><span className="about-hero-stat__num">2</span><span className="about-hero-stat__lbl">Units</span></div>
            <div className="about-hero-stat__div"/>
            <div className="about-hero-stat"><span className="about-hero-stat__num">6+</span><span className="about-hero-stat__lbl">Clients</span></div>
          </div>
        </div>
      </section>

      {/* ── WHO WE ARE ── */}
      <section className="section about-who" ref={whoRef}>
        <div className="container about-who__grid about-who__grid--no-img">
          <div className="about-who__text about-who__text--full">
            <h2 className="section-title reveal from-right delay-1">A Legacy of<br/><span style={{color:'var(--red)'}}>Engineering Excellence</span></h2>
            <div className="red-line reveal from-right delay-2" />
            <p className="about-who__body reveal from-right delay-3">
              MILLTECH CNC is established in the year 2002 with a bold and innovative high-tech initiation of well-qualified MILLTECH Engineers. We started functioning from our CNC Machining Unit I and added the second Heavy Duty Machining unit, both located at Thirumudivakkam, Chennai. We got ISO 9001:2015 certification for our Unit I.
            </p>
            <p className="about-who__body reveal from-right delay-4">
              We have more than 25 years of experience in providing high quality heavy and critical Fabrication, machining, Assembly, Surface Treatment, Painting of many engineering goods for different applications — ISRO, BrahMos, Earth moving Equipment, Thermal power plant High Pressure Tanks, Machining of Heavy-forging alloys, Valve Bodies, Impellers, Defence Products, and high accuracy aerospace components to giant Corporate Companies both Private and Government.
            </p>

            {/* Vision / Mission / Quality — image-icon shape style */}
            <div className="about-vmq reveal from-right delay-5">
              {VMQ.map((v, i) => (
                <div key={i} className="about-vmq__card" style={{background: v.bg, borderColor: v.border}}>
                  <div className="about-vmq__icon-wrap">
                    <img src={v.img} alt={v.heading} className="about-vmq__icon-img" />
                  </div>
                  <div>
                    <strong style={{color: v.color}}>{v.heading}</strong>
                    <p>{v.text}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="about-who__tags reveal from-right" style={{marginTop:'1.5rem'}}>
              {['Aluminium Alloy','Stainless Steel','Mild Steel','High-Alloy Steel','Aerospace Grade'].map(t => (
                <span key={t} className="about-who__tag">{t}</span>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── TIMELINE ── */}
      <section className="section timeline-section" ref={timelineRef}>
        <div className="container">
          <div className="section-header reveal" style={{textAlign:'center',marginBottom:'4rem'}}>
            <p className="section-eyebrow" style={{justifyContent:'center'}}>Our Journey</p>
            <h2 className="section-title">Milestones</h2>
          </div>
          <div className="timeline">
            {TIMELINE.map((item, i) => (
              <div key={i} className={`timeline-item reveal ${i % 2 === 0 ? 'from-left' : 'from-right'} delay-${Math.min(i+1,6)}`}>
                <div className="timeline-item__marker">
                  <div className="timeline-item__dot" />
                  <div className="timeline-item__line" />
                </div>
                <div className="timeline-item__card">
                  <span className="timeline-item__year">{item.year}</span>
                  <h3 className="timeline-item__title">{item.title}</h3>
                  <p className="timeline-item__desc">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── LOCATIONS ── */}
      <section className="section location-section" ref={locationRef}>
        <div className="container">
          <div style={{textAlign:'center',marginBottom:'3rem'}}>
            <h2 className="section-title">Our Locations</h2>
          </div>
          <div className="location-grid">
            <div className="location-card reveal from-left">
              <div className="location-card__num">Unit I</div>
              <h3 className="location-card__title">SIDCO Industrial Estate</h3>
              <p className="location-card__addr">
                No. 101/1, 14th Main Road,<br/>
                SIDCO Industrial Estate,<br/>
                Thirumudivakkam,<br/>
                Chennai – 600 132
              </p>
              <a
                href="https://www.google.com/maps/place/MILLTECH+CNC/@12.9770853,80.083075,17z/data=!3m1!4b1!4m6!3m5!1s0x3a5267473fc40905:0x11649cef00b96a27!8m2!3d12.9770853!4d80.083075!16s%2Fg%2F11fmy0mnr1?entry=ttu&g_ep=EgoyMDI2MDYxNi4wIKXMDSoASAFQAw%3D%3D"
                target="_blank"
                rel="noopener noreferrer"
                className="location-card__link"
              >
                View on Map →
              </a>
            </div>
            <div className="location-card reveal from-right">
              <div className="location-card__num">Unit II</div>
              <h3 className="location-card__title">MKB Industrial Estate</h3>
              <p className="location-card__addr">
                Plot No. 28, Arul Murugan Nagar,<br/>
                MKB Industrial Estate,<br/>
                Thirumudivakkam,<br/>
                Chennai – 600 132
              </p>
              <a
                href="https://www.google.com/maps/place/MILLTECH+CNC+---UNIT+2/@12.9645983,80.0830425,17z/data=!3m1!4b1!4m6!3m5!1s0x3a52f5400a72f09d:0x645c791a6668f1a4!8m2!3d12.9645931!4d80.0856174!16s%2Fg%2F11flhf5kmd?entry=ttu&g_ep=EgoyMDI2MDYxNi4wIKXMDSoASAFQAw%3D%3D"
                target="_blank"
                rel="noopener noreferrer"
                className="location-card__link"
              >
                View on Map →
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* ── ISO BADGE ── */}
      <section className="iso-section">
        <div className="container iso-content">
          <div className="iso-badge-large">
            <div className="iso-badge-large__ring">
              <svg viewBox="0 0 200 200">
                <circle cx="100" cy="100" r="90" fill="none" stroke="var(--red)" strokeWidth="2" strokeDasharray="6 4"/>
                <circle cx="100" cy="100" r="75" fill="none" stroke="rgba(192,22,28,0.3)" strokeWidth="1"/>
              </svg>
              <div className="iso-badge-large__inner">
                <span className="iso-badge-large__label">ISO</span>
                <span className="iso-badge-large__num">9001</span>
                <span className="iso-badge-large__year">2015</span>
                <span className="iso-badge-large__cert">CERTIFIED</span>
              </div>
            </div>
          </div>
          <div className="iso-text">
            <h2 className="section-title">ISO 9001:2015<br/>Certified Organisation</h2>
            <div className="red-line"/>
            <p style={{color:'var(--txt-3)',lineHeight:1.8}}>
              Our Unit I holds ISO 9001:2015 certification — a testament to our consistent quality management system. Every component we produce is traceable, documented, and inspected to the highest standards before delivery.
            </p>
          </div>
        </div>
      </section>

      {/* ── CLIENTS GRID WITH LOGOS ── */}
      <section className="section clients-logo-section" ref={clientsRef}>
        <div className="container">
          <div className="section-header reveal" style={{textAlign:'center',marginBottom:'3rem'}}>
     
            <h2 className="section-title">Our Valued Customers</h2>
          </div>
          <div className="clients-logo-grid stagger-children">
            {CLIENTS.map((c, i) => (
              <div key={c.name} className={`client-logo-card reveal delay-${i+1}`} style={{'--clc': c.color}}>
                <div className="client-logo-card__glow"/>
                <div className="client-logo-card__img-wrap">
                  <img src={c.logo} alt={c.name} className="client-logo-card__img"/>
                </div>
                <h3 className="client-logo-card__name">{c.name}</h3>
                <p className="client-logo-card__full">{c.full}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="cta-strip">
        <div className="container cta-strip__inner">
          <div>
            <h2 className="cta-strip__heading">Ready to work with us?</h2>
            <p className="cta-strip__sub">Get in touch for quotes and technical discussions.</p>
          </div>
          <Link to="/contact" className="btn btn-white cta-strip__btn">Contact Us →</Link>
        </div>
      </section>
    </main>
  );
};

export default AboutUs;